import React from "react";

export function About() {
    return (
        <>
            <center><br/><br/><br/><br/>
            <h1 className="text-5xl md:text-5xl font-bold mb-6">Monroe Fire Department District #1 Mission and Policy Statements:</h1>
<hr/>
<p><font size="+1"><u><strong>Our mission goal is to:</strong></u></font><br/>
</p><ul>
<li><strong>Provide emergency services to protect  life and property from natural or man-made events to the residents of Monroe  Fire District #1 and neighboring Mutual Aid Emergency Service Departments. </strong></li>
<li><strong>To provide public Fire Safety  Prevention Education, Fire Inspections, and Incident Investigations.</strong></li>
<li><strong>To provide assistance to County, State,  and Federal Emergency Organizations as capable.</strong></li>
</ul>
<br/>
<br/>
<p><font size="+1"><strong><u>Commissioners’ policy statement:</u></strong></font></p>
<p><strong>The Commissioners of Monroe Fire  District #1 are committed to providing the appropriate oversight and support of the  Monroe Volunteer Fire Dept. and the Bureau Of Fire Prevention.</strong></p>
<p><strong>The Board is also committed to acting in a fiscally responsible manner on behalf of the residents of Monroe Fire District #1.</strong></p>
<center>
  <form method="LINK" action="#top">
    <strong>
    </strong>
  </form>
</center>
            </center>
        </>
    )
}